import * as Dialog from "@radix-ui/react-dialog";
import { AlertTriangle } from "lucide-react";
import type { ChainAccess } from "../types/chain";

interface AutoArrangeConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  access: ChainAccess;
  onConfirm: () => void;
}

const AUDIENCE: Record<Exclude<ChainAccess, "private">, string> = {
  corp: "everyone in your corp",
  alliance: "everyone in your alliance",
  public: "anyone who can view it",
};

export function AutoArrangeConfirmModal({
  open,
  onOpenChange,
  access,
  onConfirm,
}: AutoArrangeConfirmModalProps) {
  const audience = access === "private" ? "" : AUDIENCE[access];

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="modal__overlay" />
        <Dialog.Content className="modal__content">
          <Dialog.Title className="modal__title">
            <AlertTriangle size={16} aria-hidden /> Auto-arrange shared chain
          </Dialog.Title>
          <Dialog.Description className="form__hint form__hint--warn">
            This chain isn't private — auto-arranging repositions every system
            and replaces the saved layout for {audience}.
          </Dialog.Description>
          <div className="modal__actions">
            <button
              type="button"
              className="modal__btn"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="modal__btn modal__btn--primary"
              onClick={onConfirm}
            >
              Auto-arrange
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
